import React from 'react';
import { Box, Icon, Text, VStack } from '@chakra-ui/react';
interface Props {
  icon?: React.ComponentType;
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export function EmptyState({ icon: IconComp, title, description, children }: Props) {
  return (
    <VStack spacing={4} py={16} px={6} textAlign="center" maxW="md" mx="auto">
      {IconComp && (
        <Box
          w={14}
          h={14}
          borderRadius="2xl"
          bg="whiteAlpha.100"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon as={IconComp} boxSize={7} color="teal.300" />
        </Box>
      )}
      <Text fontSize="lg" fontWeight="600" color="whiteAlpha.900">
        {title}
      </Text>
      {description && (
        <Text fontSize="sm" color="whiteAlpha.600" lineHeight="tall">
          {description}
        </Text>
      )}
      {children}
    </VStack>
  );
}
